export default __webpack_public_path__ + "static/media/photo.7dd330f9.svg";